<template>
  <img
    src="https://www.samsungfire.com/m/resources/images/front/bg_car01.png"
    height="98"
    width="138"
    alt="car"
    class="-mr-2 !h-24 object-cover object-left"
  />
</template>

<script lang="ts" setup></script>

<style scoped></style>
